import { kyber } from 'kyber-crystals';

/**
 * Encapsulates a shared secret using Kyber key encapsulation mechanism (KEM).
 * 
 * @param receiverKyberPublicKey - The recipient’s Kyber public key (Uint8Array)
 * @returns A promise that resolves to an object containing:
 *  - `ciphertext`: the encapsulated key to send to the receiver
 *  - `sharedSecret`: the derived shared secret to be used by the sender
 */
export async function encapsulateKyberSecret(
  receiverKyberPublicKey: Uint8Array
): Promise<{
  ciphertext: Uint8Array;
  sharedSecret: Uint8Array;
}> {
  const { cyphertext: ciphertext, secret: sharedSecret } = await kyber.encrypt(receiverKyberPublicKey);

  return {
    ciphertext,
    sharedSecret,
  };
}